import { render, staticRenderFns } from "./UpgradeToAccess.vue?vue&type=template&id=820b8f08&"
import script from "./UpgradeToAccess.vue?vue&type=script&lang=js&"
export * from "./UpgradeToAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports